/**
 * 技能审核
 */
<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>技能审核</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form :inline="true" class="user-search">
      <el-form-item label="搜索：">
        <el-input
          size="small"
          v-model="keyword"
          placeholder="输入技能名称/接单方昵称/手机号"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="审核状态：">
        <el-select size="small" v-model="status" clearable placeholder="全部状态">
          <el-option label="待审核" :value="1"></el-option>
          <el-option label="审核通过" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" @click="resetSearch">重置</el-button>
        <el-button size="small" icon="el-icon-refresh" :loading="refreshing" @click="refreshList">刷新</el-button>
      </el-form-item>
    </el-form>

    <el-alert
      :title="`当前有 ${pendingCount} 条待审核申请`"
      type="warning"
      :closable="false"
      show-icon
      class="pending-alert"
    ></el-alert>

    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%;"
    >
      <el-table-column prop="id" label="技能ID" width="90"></el-table-column>
      <el-table-column label="技能图片" width="110" align="center">
        <template slot-scope="scope">
          <div
            v-if="getSkillMedia(scope.row)"
            class="media-thumb"
            @click="openImagePreview(scope.row, 'skillImage', '技能图/证书图')"
          >
            <video
              v-if="getSkillMedia(scope.row).type === 'video'"
              class="skill-image"
              :src="getVideoFirstFrameUrl(getSkillMedia(scope.row).url)"
              preload="auto"
              playsinline
              muted
              @loadedmetadata="prepareVideoFirstFrame"
            ></video>
            <el-image
              v-else
              class="skill-image"
              :src="getSkillMedia(scope.row).url"
              fit="cover"
            >
              <div slot="error" class="image-slot">无图</div>
            </el-image>
            <div v-if="getSkillMedia(scope.row).type === 'video'" class="media-mask">视频</div>
          </div>
          <div v-else class="image-slot">无图</div>
        </template>
      </el-table-column>
      <el-table-column label="申请视频/作品" width="130" align="center">
        <template slot-scope="scope">
          <div
            v-if="getWorkMedia(scope.row)"
            class="media-thumb"
            @click="openImagePreview(scope.row, 'workImage', '申请视频/作品')"
          >
            <video
              v-if="getWorkMedia(scope.row).type === 'video'"
              class="skill-image"
              :src="getVideoFirstFrameUrl(getWorkMedia(scope.row).url)"
              preload="auto"
              playsinline
              muted
              @loadedmetadata="prepareVideoFirstFrame"
              @loadeddata="prepareVideoFirstFrame"
              @seeked="prepareVideoFirstFrame"
            ></video>
            <el-image
              v-else
              class="skill-image"
              :src="getWorkMedia(scope.row).url"
              fit="cover"
            >
              <div slot="error" class="image-slot">无图</div>
            </el-image>
            <div v-if="getWorkMedia(scope.row).type === 'video'" class="media-mask">点击播放</div>
          </div>
          <div v-else class="image-slot">未上传</div>
        </template>
      </el-table-column>
      <el-table-column label="技能分类" min-width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.classifyName || '-' }}</div>
          <div class="sub-text">{{ scope.row.classifyTwoName || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="接单方" min-width="180">
        <template slot-scope="scope">
          <div class="member-cell">
            <el-image class="avatar" :src="$adminImageUrl(scope.row.headPortrait)" fit="cover">
              <div slot="error" class="avatar avatar-fallback">无图</div>
            </el-image>
            <div>
              <div>{{ scope.row.username || '-' }}</div>
              <div class="sub-text">{{ scope.row.mobile || '-' }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="接单状态" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.memberStatus === 1 ? 'success' : 'info'" size="mini">
            {{ scope.row.memberStatus === 1 ? '在线接单' : '下线' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="联系人/电话" min-width="170" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.contact || '-' }}</div>
          <div class="sub-text">{{ scope.row.phone || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="城市" min-width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.desiredCity || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="价格" width="110" align="center">
        <template slot-scope="scope">
          <div>{{ formatMoney(scope.row.price) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="审核状态" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="getAuditStatusTagType(scope.row)" size="mini">
            {{ getAuditStatusText(scope.row) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="驳回原因" min-width="280">
        <template slot-scope="scope">
          <div class="audit-remark-full">{{ scope.row.auditRemark || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="160">
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="图片预览" width="180" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="openImagePreview(scope.row, 'skillImage', '技能图/证书图')"
          >技能图</el-button>
          <el-button
            size="mini"
            type="primary"
            plain
            @click="openImagePreview(scope.row, 'workImage', '作品图')"
          >作品图/视频</el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="220" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="openDetail(scope.row)"
          >查看详情</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="openMemberSkills(scope.row)"
          >查看接单技能</el-button>
          <el-button
            v-if="Number(scope.row.status) === 1"
            size="mini"
            type="success"
            @click="changeSkillStatus(scope.row, 0)"
          >审核通过</el-button>
          <el-button
            v-if="Number(scope.row.status) === 1"
            size="mini"
            type="danger"
            @click="openRejectDialog(scope.row)"
          >驳回</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>

    <el-dialog
      title="接单方技能"
      :visible.sync="memberSkillVisible"
      width="70%"
    >
      <div v-if="currentMember.id" class="member-summary">
        <div>接单方：{{ currentMember.username || '-' }}</div>
        <div>手机号：{{ currentMember.mobile || '-' }}</div>
        <div>当前技能数：{{ memberSkillList.length }}</div>
      </div>

      <el-table
        size="small"
        :data="memberSkillList"
        border
        v-loading="memberSkillLoading"
        element-loading-text="拼命加载中"
      >
        <el-table-column prop="id" label="技能ID" width="90"></el-table-column>
        <el-table-column label="技能分类" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{ scope.row.classifyName || '-' }}</div>
            <div class="sub-text">{{ scope.row.classifyTwoName || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="价格" width="100" align="center">
          <template slot-scope="scope">
            <div>{{ formatMoney(scope.row.price) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="联系人" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{ scope.row.contact || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="电话" width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{ scope.row.phone || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="120" align="center">
          <template slot-scope="scope">
            <el-tag :type="getAuditStatusTagType(scope.row)" size="mini">
              {{ getAuditStatusText(scope.row) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="驳回原因" min-width="280">
          <template slot-scope="scope">
            <div class="audit-remark-full">{{ scope.row.auditRemark || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="介绍" min-width="260" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{ scope.row.introduce || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="图片预览" width="180" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="openDetail(scope.row)"
            >详情</el-button>
            <el-button
              size="mini"
              @click="openImagePreview(scope.row, 'skillImage', '技能图/证书图')"
            >技能图</el-button>
            <el-button
              size="mini"
              type="primary"
              plain
              @click="openImagePreview(scope.row, 'workImage', '作品图')"
            >作品图/视频</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      title="填写驳回原因"
      :visible.sync="rejectDialogVisible"
      width="420px"
      @close="closeRejectDialog"
    >
      <el-input
        v-model="rejectReason"
        type="textarea"
        :rows="4"
        maxlength="100"
        show-word-limit
        placeholder="请输入驳回原因，用户提交后会看到"
      />
      <span slot="footer">
        <el-button @click="closeRejectDialog">取消</el-button>
        <el-button type="danger" @click="confirmReject">确认驳回</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="previewTitle"
      :visible.sync="previewVisible"
      width="760px"
    >
      <div v-if="previewMediaList.length" class="preview-grid">
        <div
          v-for="(item, index) in previewMediaList"
          :key="item.url + '-' + index"
          class="preview-card"
        >
          <video
            v-if="item.type === 'video'"
            class="preview-video"
            :src="getVideoFirstFrameUrl(item.url)"
            preload="auto"
            playsinline
            controls
            muted
            @loadedmetadata="prepareVideoFirstFrame"
            @loadeddata="prepareVideoFirstFrame"
            @seeked="prepareVideoFirstFrame"
          ></video>
          <el-image
            v-else
            class="preview-image"
            :src="item.url"
            fit="cover"
          >
            <div slot="error" class="preview-empty">加载失败</div>
          </el-image>
          <div class="preview-actions">
            <el-button size="mini" type="text" @click="openImageInNewTab(item.url)">
              {{ item.type === 'video' ? '查看原视频' : '查看原图' }}
            </el-button>
          </div>
        </div>
      </div>
      <div v-else class="preview-no-data">暂无媒体</div>
    </el-dialog>

    <el-dialog
      title="技能详情"
      :visible.sync="detailVisible"
      width="820px"
    >
      <div v-if="detailData" class="detail-wrapper">
        <div class="detail-section">
          <div class="detail-title">基础信息</div>
          <div class="detail-grid">
            <div class="detail-item"><span>技能ID：</span>{{ detailData.id || '-' }}</div>
            <div class="detail-item"><span>接单方：</span>{{ detailData.username || '-' }}</div>
            <div class="detail-item"><span>手机号：</span>{{ detailData.mobile || detailData.phone || '-' }}</div>
            <div class="detail-item"><span>分类：</span>{{ formatClassify(detailData) }}</div>
            <div class="detail-item"><span>城市：</span>{{ detailData.desiredCity || '-' }}</div>
            <div class="detail-item"><span>联系人：</span>{{ detailData.contact || '-' }}</div>
            <div class="detail-item"><span>接单状态：</span>{{ detailData.memberStatus === 1 ? '在线接单' : '下线' }}</div>
            <div class="detail-item"><span>审核状态：</span>{{ getAuditStatusText(detailData) }}</div>
            <div class="detail-item detail-item-full audit-remark-full"><span>驳回原因：</span>{{ detailData.auditRemark || '-' }}</div>
            <div class="detail-item"><span>创建时间：</span>{{ transformDate(detailData.createTime) }}</div>
            <div class="detail-item"><span>更新时间：</span>{{ transformDate(detailData.updateTime) }}</div>
          </div>
        </div>

        <div class="detail-section">
          <div class="detail-title">收费信息</div>
          <div class="detail-grid">
            <div class="detail-item"><span>价格：</span>{{ formatMoney(detailData.price) }}</div>
            <div class="detail-item"><span>计费方式：</span>{{ detailData.chargeMode || '-' }}</div>
            <div class="detail-item"><span>工龄：</span>{{ detailData.workingAge || '-' }}</div>
            <div class="detail-item"><span>免费公里：</span>{{ formatDistance(detailData.freeKm) }}</div>
            <div class="detail-item"><span>超出每公里：</span>{{ formatMoney(detailData.chargeKm) }}</div>
          </div>
        </div>

        <div class="detail-section">
          <div class="detail-title">技能介绍</div>
          <div class="detail-text">{{ detailData.introduce || '-' }}</div>
        </div>

        <div class="detail-section">
          <div class="detail-title">自定义字段</div>
          <div v-if="getCustomDataList(detailData).length" class="custom-list">
            <div
              v-for="(item, index) in getCustomDataList(detailData)"
              :key="(item.name || 'item') + '-' + index"
              class="custom-item"
            >
              <span>{{ item.name || ('字段' + (index + 1)) }}：</span>{{ item.value || '-' }}
            </div>
          </div>
          <div v-else class="detail-text">暂无自定义字段</div>
        </div>

        <div class="detail-section">
          <div class="detail-title">申请图片与视频</div>
          <div v-if="getAuditMediaList(detailData).length" class="detail-media-list">
            <div
              v-for="(item, index) in getAuditMediaList(detailData)"
              :key="item.source + '-' + item.url + '-' + index"
              class="detail-media-card"
            >
              <div class="detail-media-label">{{ item.source }}</div>
              <video
                v-if="item.type === 'video'"
                class="detail-media-player"
                :src="getVideoFirstFrameUrl(item.url)"
                preload="auto"
                playsinline
                controls
                muted
                @loadedmetadata="prepareVideoFirstFrame"
                @loadeddata="prepareVideoFirstFrame"
                @seeked="prepareVideoFirstFrame"
              ></video>
              <el-image
                v-else
                class="detail-media-player"
                :src="item.url"
                fit="contain"
                :preview-src-list="[item.url]"
              >
                <div slot="error" class="preview-empty">加载失败</div>
              </el-image>
              <div v-if="item.type === 'video'" class="detail-media-actions">
                <el-button size="mini" type="text" @click="openImageInNewTab(item.url)">打开原视频</el-button>
              </div>
            </div>
          </div>
          <div v-else class="detail-text">用户未上传申请图片或视频</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSkillAuditList, getPendingSkillAuditCount, setSkillStatus, getMemberSkillList } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import { getVideoFirstFrameUrl, prepareVideoFirstFrame } from '../../utils/videoFirstFrame'
import { getAdminAuditMediaList, isAuditVideoMedia, normalizeAuditMediaUrl } from '../../utils/adminAuditMedia'

export default {
  components: {
    Pagination
  },
  data() {
    return {
      loading: false,
      refreshing: false,
      refreshTimer: null,
      keyword: '',
      status: 1,
      pendingCount: 0,
      listData: [],
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      previewVisible: false,
      previewTitle: '图片预览',
      previewMediaList: [],
      detailVisible: false,
      detailData: null,
      rejectDialogVisible: false,
      rejectReason: '',
      currentAuditRow: null,
      memberSkillVisible: false,
      memberSkillLoading: false,
      memberSkillList: [],
      currentMember: {}
    }
  },
  created() {
    this.getList(1)
    this.loadPendingCount()
    this.refreshTimer = setInterval(() => {
      this.getList(this.pageparm.currentPage, true)
      this.loadPendingCount()
    }, 15000)
  },
  beforeDestroy() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    }
  },
  methods: {
    getVideoFirstFrameUrl,
    prepareVideoFirstFrame,
    parseJsonArray(value) {
      if (!value) {
        return []
      }
      if (Array.isArray(value)) {
        return value
      }
      try {
        var parsed = JSON.parse(value)
        if (Array.isArray(parsed)) {
          return parsed
        }
        return typeof parsed === 'string' ? [parsed] : []
      } catch (e) {
        if (typeof value === 'string' && /^https?:\/\//.test(value)) {
          return [value]
        }
        return []
      }
    },
    isVideoFile(url) {
      return isAuditVideoMedia(url)
    },
    normalizeMediaUrl(item) {
      return normalizeAuditMediaUrl(item)
    },
    getMediaList(row, field) {
      return getAdminAuditMediaList(row && row[field])
    },
    getPreviewMedia(row, field, fallback) {
      var mediaList = this.getMediaList(row, field)
      if (mediaList.length > 0) {
        var firstImage = mediaList.find(function(item) {
          return item.type === 'image'
        })
        return firstImage || mediaList[0]
      }
      if (fallback) {
        var fallbackUrl = this.normalizeMediaUrl(fallback)
        return {
          url: fallbackUrl,
          type: this.isVideoFile(fallbackUrl) ? 'video' : 'image'
        }
      }
      return null
    },
    getImageList(row, field) {
      return this.parseJsonArray(row[field])
    },
    getCustomDataList(row) {
      return this.parseJsonArray(row.customData)
    },
    getSkillMedia(row) {
      return this.getPreviewMedia(row, 'skillImage', row.picture || '')
    },
    getWorkMedia(row) {
      var mediaList = this.getMediaList(row, 'workImage')
      return mediaList.find(item => item.type === 'video') || mediaList[0] || null
    },
    getAuditMediaList(row) {
      return this.getMediaList(row, 'skillImage').map(item => Object.assign({ source: '技能图/证书图' }, item))
        .concat(this.getMediaList(row, 'workImage').map(item => Object.assign({ source: item.type === 'video' ? '申请视频' : '作品图' }, item)))
    },
    getSkillImage(row) {
      var media = this.getSkillMedia(row)
      return media ? media.url : ''
    },
    formatClassify(row) {
      var classify = row.classifyName || ''
      var classifyTwo = row.classifyTwoName || ''
      if (classify && classifyTwo) {
        return classify + ' / ' + classifyTwo
      }
      return classify || classifyTwo || '-'
    },
    formatMoney(value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      return (value / 100).toFixed(2)
    },
    formatDistance(value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      return value + ' km'
    },
    getAuditStatusText(row) {
      var status = Number(row && row.status)
      var auditRemark = row && row.auditRemark ? String(row.auditRemark).trim() : ''
      if (status === 0) {
        return Number(row && row.enabled) === 0 ? '审核通过（已停用）' : '审核通过'
      }
      return auditRemark ? '审核未通过' : '待审核'
    },
    getAuditStatusTagType(row) {
      var status = Number(row && row.status)
      var auditRemark = row && row.auditRemark ? String(row.auditRemark).trim() : ''
      if (status === 0) {
        return 'success'
      }
      return auditRemark ? 'danger' : 'warning'
    },
    updatePendingCount() {
      this.pendingCount = (this.listData || []).filter(function(item) {
        return Number(item.status) === 1 && !(item.auditRemark && String(item.auditRemark).trim())
      }).length
    },
    loadPendingCount() {
      getPendingSkillAuditCount({}).then(res => {
        if (res && res.code === 200) {
          this.pendingCount = Number(res.data && res.data.count) || 0
        }
      }).catch(() => {})
    },
    getList(page, silent) {
      var self = this
      if (self.loading || self.refreshing) {
        return
      }
      if (silent) {
        self.refreshing = true
      } else {
        self.loading = true
      }
      var parameter = {
        keyword: self.keyword,
        page: (page - 1) * 20
      }
      if (self.status !== '' && self.status !== null && self.status !== undefined) {
        parameter.status = Number(self.status)
      }
      getSkillAuditList(parameter).then(function (res) {
        self.loading = false
        self.refreshing = false
        if (res.code === 200) {
          self.listData = res.data.list || []
          self.loadPendingCount()
          self.pageparm.currentPage = page
          self.pageparm.total = res.data.count || 0
          return
        }
        self.listData = []
        self.loadPendingCount()
        self.$message({
          type: 'info',
          message: res.msg
        })
      }).catch(function () {
        self.loading = false
        self.refreshing = false
      })
    },
    refreshList() {
      this.getList(this.pageparm.currentPage, true)
    },
    search() {
      this.getList(1)
    },
    resetSearch() {
      this.keyword = ''
      this.status = 1
      this.getList(1)
    },
    openImagePreview(row, field, title) {
      this.previewTitle = title
      this.previewMediaList = this.getMediaList(row, field)
      this.previewVisible = true
    },
    openImageInNewTab(url) {
      if (!url) {
        return
      }
      window.open(url, '_blank')
    },
    openDetail(row) {
      this.detailData = Object.assign({}, row)
      this.detailVisible = true
    },
    callFather(parm) {
      this.getList(parm.currentPage)
    },
    changeSkillStatus(row, status, reason) {
      var self = this
      var actionText = status === 0 ? '审核通过' : '驳回'
      var auditRemark = status === 0 ? '' : (reason || row.auditRemark || '')
      self.$confirm('确定要' + actionText + '该技能吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return setSkillStatus({
          id: row.id,
          status: status,
          auditRemark: auditRemark
        })
      }).then(function (res) {
        if (res.code === 200) {
          self.$message({
            type: 'success',
            message: actionText + '成功'
          })
          self.closeRejectDialog()
          self.getList(self.pageparm.currentPage)
          return
        }
        self.$message({
          type: 'info',
          message: res.msg
        })
      }).catch(function () {})
    },
    openRejectDialog(row) {
      this.currentAuditRow = row
      this.rejectReason = row.auditRemark || ''
      this.rejectDialogVisible = true
    },
    closeRejectDialog() {
      this.rejectDialogVisible = false
      this.rejectReason = ''
      this.currentAuditRow = null
    },
    confirmReject() {
      var reason = this.rejectReason ? this.rejectReason.trim() : ''
      if (!reason) {
        this.$message({
          type: 'warning',
          message: '请输入驳回原因'
        })
        return
      }
      if (!this.currentAuditRow) {
        this.closeRejectDialog()
        return
      }
      this.changeSkillStatus(this.currentAuditRow, 1, reason)
    },
    openMemberSkills(row) {
      var self = this
      self.currentMember = {
        id: row.userId,
        username: row.username,
        mobile: row.mobile
      }
      self.memberSkillVisible = true
      self.memberSkillLoading = true
      self.memberSkillList = []
      getMemberSkillList({
        userId: row.userId
      }).then(function (res) {
        self.memberSkillLoading = false
        if (res.code === 200) {
          self.memberSkillList = res.data.list || []
          return
        }
        self.$message({
          type: 'info',
          message: res.msg
        })
      }).catch(function () {
        self.memberSkillLoading = false
      })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.pending-alert {
  margin-bottom: 16px;
}

.skill-image {
  width: 70px;
  height: 70px;
  border-radius: 8px;
  background: #f5f7fa;
}

.media-thumb {
  position: relative;
  width: 70px;
  height: 70px;
  cursor: pointer;
}

.media-mask {
  position: absolute;
  right: 4px;
  bottom: 4px;
  padding: 0 6px;
  line-height: 18px;
  border-radius: 10px;
  color: #fff;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.55);
}

.image-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 70px;
  color: #909399;
  font-size: 12px;
  background: #f5f7fa;
}

.member-cell {
  display: flex;
  align-items: center;
}

.avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  margin-right: 10px;
  background: #f5f7fa;
}

.avatar-fallback {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 12px;
}

.sub-text {
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}

.member-summary {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  color: #606266;
}

.preview-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.preview-card {
  width: 160px;
}

.preview-image {
  width: 160px;
  height: 160px;
  border-radius: 8px;
  background: #f5f7fa;
}

.preview-video {
  width: 160px;
  height: 160px;
  border-radius: 8px;
  background: #000;
  object-fit: cover;
}

.preview-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 160px;
  color: #909399;
  font-size: 12px;
  background: #f5f7fa;
}

.preview-actions {
  text-align: center;
  margin-top: 4px;
}

.preview-no-data {
  text-align: center;
  color: #909399;
  line-height: 120px;
}

.detail-wrapper {
  max-height: 70vh;
  overflow-y: auto;
}

.detail-section {
  margin-bottom: 20px;
}

.detail-title {
  margin-bottom: 12px;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.detail-grid,
.custom-list {
  display: flex;
  flex-wrap: wrap;
}

.detail-item,
.custom-item {
  width: 50%;
  line-height: 32px;
  color: #606266;
}

.detail-item span,
.custom-item span {
  color: #303133;
  font-weight: 500;
}

.detail-item-full {
  width: 100%;
}

.audit-remark-full {
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 1.6;
}

.detail-text {
  line-height: 24px;
  color: #606266;
  white-space: pre-wrap;
  word-break: break-all;
}

.detail-media-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.detail-media-card {
  min-width: 0;
  padding: 10px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fafafa;
}

.detail-media-label {
  margin-bottom: 8px;
  color: #606266;
  font-size: 13px;
}

.detail-media-player {
  display: block;
  width: 100%;
  height: 240px;
  object-fit: contain;
  background: #000;
}

.detail-media-actions {
  margin-top: 6px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/goods/Goods.vue